// extracted by mini-css-extract-plugin
export default {"leftSideWrapper":"vsVU0","center":"WBw+A","backBtn":"Ep7XF"};